import qs from 'qs';
import _ from 'underscore';
import AdminServerActionCreators from '../actions/AdminServerActionCreators';
import AdminConstants from '../constants/AdminConstants';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import client from './rest/AdminClient';
const Actions = AdminConstants.ActionTypes;
export const DOCUMENTS_PER_PAGE = 10;
const availableDriversQuery = {
    select: 'first_name last_name carrier coords',
    populate: [
        {
            path: 'carrier',
            select: 'first_name last_name email phone name picture',
        },
    ],
    available: true,
};
const getDriverWaypoints = (id, start, end) => {
    const query = qs.stringify({
        start,
        end,
    });
    return client({
        method: 'GET',
        path: `/api/audits/drivers/${id}/waypoints?${query}`,
    });
};
const nearbyDriversQuery = {
    select: 'first_name last_name phone pending_offers carrier equipment_class coords jobs available has_active_jobs',
    populate: [
        {
            path: 'carrier',
            select: 'name authorized',
        },
    ],
    paginate: true,
    available: true,
    authorized: true,
    carrier_authorized: true,
    per_page: 200,
};
const getAuthorizedDriversQuery = {
    select: 'first_name last_name carrier coords username available equipment_class',
    populate: [
        {
            path: 'carrier',
            select: 'first_name last_name email phone name picture authorized',
        },
    ],
    authorized: false,
    per_page: 20,
    paginate: true,
};
const getAvailableDriversByMarketQuery = {
    select: '_id first_name last_name carrier',
    populate: [
        {
            path: 'carrier',
            select: 'name',
        },
    ],
    authorized: true,
    per_page: 500,
    available: true,
};
const getDriverNamesByCarrierQuery = {
    select: '_id first_name last_name username documents picture',
    populate: [
        {
            path: 'carrier',
            select: 'name',
        },
    ],
    authorized: true,
    per_page: 20,
};
function getDriverManifests(id, params = {}) {
    const query = qs.stringify(Object.assign({ page: params.page || 1, per_page: params.per_page || DOCUMENTS_PER_PAGE }, params));
    return client({
        method: 'GET',
        path: `/api/1/drivers/${id}/manifests?${query}`,
    });
}
function departManifest(manifest) {
    return client({
        method: 'POST',
        path: `/api/v2/jobs/bulk/pickup/complete`,
        entity: JSON.stringify(manifest),
    });
}
function getAuthorizedDrivers(params = {}, options = {}) {
    const query = _.extend(getAuthorizedDriversQuery, params, options);
    const queryString = qs.stringify(query);
    return client({
        method: 'GET',
        path: `/admin/api/v2/drivers?${queryString}`,
    });
}
function getAvailableDrivers(params = {}, options = {}) {
    console.log('getting available drivers');
    const query = _.extend(availableDriversQuery, params, options);
    const queryString = qs.stringify(query);
    return client({
        method: 'GET',
        path: `/admin/api/v2/drivers?${queryString}`,
    });
}
function getNearbyDrivers(params = {}, options = {}) {
    const query = _.extend(nearbyDriversQuery, params, options);
    const queryString = qs.stringify(query);
    return client({
        method: 'GET',
        path: `/admin/api/v2/drivers?${queryString}`,
    });
}
export function acceptOffer({ offerId, driverId }) {
    return client({
        method: 'PUT',
        path: '/api/1/offers/accept',
        entity: JSON.stringify({
            offer_id: offerId,
            driver_id: driverId,
            accept: true,
            by_proxy: true,
        }),
    });
}
const getDriverNamesByCarrier = async (carrierId, near = []) => {
    const queryString = qs.stringify(Object.assign(Object.assign({ carriers: [carrierId] }, getDriverNamesByCarrierQuery), { near }));
    return client({
        method: 'GET',
        path: `/admin/api/v2/drivers?${queryString}`,
    });
};
function getAvailableDriversByMarket(params = {}, options = {}) {
    const query = _.extend(getAvailableDriversByMarketQuery, params, options);
    const queryString = qs.stringify(query);
    return client({
        method: 'GET',
        path: `/admin/api/v2/drivers?${queryString}`,
    });
}
const Utils = {
    getDriverManifests(id, params = {}) {
        getDriverManifests(id, params).then((response) => {
            AdminServerActionCreators.receiveDriverManifest(response.entity);
        }, (response) => {
            console.error(response);
        });
    },
    departManifest(doc, options = {}) {
        return departManifest(doc).then((response) => {
            try {
                const { successes, errors, manifest } = response.entity;
                // Check if there are errors first
                if (errors && errors.length > 0) {
                    AdminServerActionCreators.driverManifestDepartFail('Something went wrong');
                }
                // Check if manifest was successfully updated (departed = true)
                else if (manifest &&
                    manifest.items &&
                    manifest.items.meta &&
                    manifest.items.meta.departed === true) {
                    AdminServerActionCreators.driverManifestDepartSuccess('Manifest departed successfully');
                    // Refetch manifests if callback provided
                    if (options.onSuccess) {
                        options.onSuccess();
                    }
                }
                // Check if manifest was already departed
                else if (manifest &&
                    manifest.items &&
                    manifest.items.meta &&
                    manifest.items.meta.departed === false) {
                    // This shouldn't happen since we're setting departed to true, but just in case
                    AdminServerActionCreators.driverManifestDepartFail('Failed to update manifest status');
                }
                // Fallback for already departed case
                else {
                    AdminServerActionCreators.driverManifestAlreadyDepartError('Manifest was already departed');
                }
                AdminServerActionCreators.receiveDepartedManifest(manifest);
                return response;
            }
            catch (error) {
                AdminServerActionCreators.driverManifestDepartFail('Something went wrong');
                console.error(error);
                throw error;
            }
        }, (response) => {
            AdminServerActionCreators.driverManifestDepartFail('Something went wrong');
            console.error(response);
            throw response;
        });
    },
    getAuthorizedDrivers() {
        getAuthorizedDrivers().then((response) => {
            AdminServerActionCreators.receiveAuthorizedDriversSuccess(response.entity.data);
        }, (response) => {
            console.error(response);
        });
    },
    getAvailableDrivers() {
        getAvailableDrivers().then((response) => {
            AdminServerActionCreators.receiveAvailableDriversSuccess(response.entity.data);
        }, (response) => {
            console.error(response);
        });
    },
    getDriverWaypoints(id, start, end) {
        getDriverWaypoints(id, start, end).then((response) => {
            AdminServerActionCreators.receiveDriverWaypointsSuccess(response.entity);
        }, (response) => {
            console.log('Failed to get driver waypoints', response);
        });
    },
    getNearbyDrivers(query) {
        getNearbyDrivers(query).then((response) => {
            AdminServerActionCreators.receiveNearbyDriversSuccess(response.entity.data, response.entity.meta.count);
        }, (response) => {
            console.error(response);
        });
    },
    acceptOffer(props) {
        acceptOffer(props).then((response) => {
            const { entity: { success }, } = response;
            if (success) {
                AdminServerActionCreators.assignDriverSuccess(props);
            }
            else {
                AdminServerActionCreators.assignDriverFail(props);
            }
        }, (response) => {
            const { entity: { success, error }, } = response;
            AdminServerActionCreators.assignDriverFail(Object.assign(Object.assign({}, props), { error,
                success }));
        });
    },
    getAvailableDriversByMarket(params, options) {
        getAvailableDriversByMarket(params, options).then((response) => {
            AdminServerActionCreators.receiveAvailableDriversSuccess(response.entity.data);
        }, (response) => {
            console.error(response);
        });
    },
    async getDriverNamesByCarrier(carrierId, near = []) {
        return getDriverNamesByCarrier(carrierId, near).then((response) => {
            return response.entity.data;
        }, (error) => {
            return error.entity;
        });
    },
};
AdminAppDispatcher.register((payload) => {
    const driverId = payload.action.driverId;
    const offerId = payload.action.offerId;
    switch (payload.action.type) {
        case Actions.ASSIGN_DRIVER_REQUEST:
            Utils.acceptOffer({ driverId, offerId });
            break;
        default:
    }
});
export default Utils;
